import { Tooltip as ReactTooltip } from "react-tooltip";

type PackageProps = {
  packageName: string | undefined;
};

const ShowPackageDot = ({ packageName }: PackageProps) => {
  if (!packageName) return null;
    const iconClass = "fas fa-star";
  const packageTooltip = "Premium Member";
  
  return (
    <>
      <i
        data-tooltip-id="package-tooltip"
        className={iconClass}
        style={{ 
          fontSize: "24px", 
          color: "#f26507",
          marginLeft: "4px",
          verticalAlign: "middle"
        }}
      />
      <ReactTooltip
        style={{ zIndex: 1000 }}
        id="package-tooltip"
        place="bottom"
        content={packageTooltip}
      />
    </>
  );
};

export default ShowPackageDot;